module.exports = __webpack_public_path__ + "static/img/emptyaddress.62356e0e.png";